// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.div_req_byte[data-v-600b6a0b] {\n  text-align: right;\n  margin-top: 2px;\n}\n.upper-textarea[data-v-600b6a0b] {\n  text-transform: uppercase;\n}\n", ""]);
// Exports
module.exports = exports;
